import React, { useContext, useState } from 'react';
import { SelectAmounts } from './SelectAmount/SelectAmounts';
import { SelectStartDate } from './SelectStartDate/SelectStartDate';
import { formatString } from '../../../assets/js/utils/formatString';
import { SelectVariant } from './SelectVariant/SelectVariant';
import { PriceCalculationContext } from '../PriceCalculationContext';
import { Dialog } from '../../../molecules/Dialog/Dialog';
import { OrgsThatAlreadyHaveThisProduct } from './OrgsThatAlreadyHaveThisProduct/OrgsThatAlreadyHaveThisProduct';

function Calculation() {
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    const {
        productData,
        selectedOrganizationsIds,
        originalSelectedOrganizationIds,
        handleToSchoolSelection,
        handleToConditionalProductsStep,
        calculationIsLoadingText,
        addToCartIsLoadingText,
        isInConditionalProductsFlow,
        resourcedTexts,
    } = useContext(PriceCalculationContext);

    const calculationType = productData?.calculationType;
    const hasVariants = productData.variantsData?.length > 0;
    const hasSelectStartDate = calculationType !== 'NoEndDate';

    const showSelectOrganizationButton = !isInConditionalProductsFlow;
    const showBackToConditionalProductsButton = isInConditionalProductsFlow;
    const nrOfSelectedOrganizations = selectedOrganizationsIds.length;

    const isLoading = Boolean(calculationIsLoadingText || addToCartIsLoadingText);

    // When a conditional product was selected, not all of the originally selected organizations need that product. Hence this filtering: we want to get and show those organizations grayed out, so the user is informed about this.
    const orgIdsThatAlreadyHaveThisProduct = originalSelectedOrganizationIds.filter(
        (id) => !selectedOrganizationsIds.includes(id),
    );

    function onToSchoolSelection() {
        setShowConfirmDialog(true);
    }

    return (
        <>
            {showConfirmDialog && (
                <Dialog
                    title={resourcedTexts.backToSchoolSelectionConfirmTitle}
                    width={600}
                    handleClose={() => setShowConfirmDialog(false)}
                    buttons={
                        <>
                            <button
                                type="button"
                                className="button secondary"
                                onClick={() => setShowConfirmDialog(false)}
                            >
                                {resourcedTexts.backToSchoolSelectionCancel}
                            </button>
                            <button
                                type="button"
                                className="button primary"
                                onClick={() => {
                                    handleToSchoolSelection();
                                    setShowConfirmDialog(false);
                                }}
                            >
                                {resourcedTexts.backToSchoolSelectionConfirm}
                            </button>
                        </>
                    }
                >
                    <p>{resourcedTexts.backToSchoolSelectionConfirmText}</p>
                </Dialog>
            )}

            <div className="calculation">
                {hasVariants && <SelectVariant />}

                {hasSelectStartDate && <SelectStartDate />}

                <SelectAmounts />

                <OrgsThatAlreadyHaveThisProduct organizationIds={orgIdsThatAlreadyHaveThisProduct} />

                <div className="calculation__buttons" id="calculationButtons">
                    {showSelectOrganizationButton && (
                        <button
                            type="button"
                            className="button secondary"
                            onClick={onToSchoolSelection}
                            disabled={isLoading}
                        >
                            <span>{resourcedTexts.selectOtherOrganizationButton}</span>
                        </button>
                    )}

                    {showBackToConditionalProductsButton && (
                        <button
                            type="button"
                            className="button secondary"
                            onClick={handleToConditionalProductsStep}
                            disabled={isLoading}
                        >
                            <span>{resourcedTexts.backToConditionalProductsButton}</span>
                        </button>
                    )}

                    <button type="submit" className="button primary" disabled={isLoading}>
                        <span className="hide-from-lg">{resourcedTexts.calculateButtonMobile}</span>
                        <span className="hide-for-md-down">
                            {nrOfSelectedOrganizations > 1
                                ? formatString(resourcedTexts.calculateButtonDesktopPlural, [
                                      nrOfSelectedOrganizations,
                                  ])
                                : formatString(resourcedTexts.calculateButtonDesktopSingular, [
                                      nrOfSelectedOrganizations,
                                  ])}
                        </span>
                    </button>
                </div>
            </div>
        </>
    );
}

export { Calculation };
